import MarginGroup from 'app/components/layout/MarginGroup';
import React, { ReactNode } from 'react';

// TODO: Move this to presentational directory?
const InputMarginGroup = ({ children }: { children: ReactNode }) => (
  <MarginGroup margin="25px">{children}</MarginGroup>
);

export default InputMarginGroup;
